import * as types from "../types";
import backend from "../api/api";
import history from "../history";
import { store } from "../store";

const getConfig = () => {
  const token = store.getState().auth.token;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  return config;
};

export const createTag = (formValues) => async (dispatch) => {
  formValues["data"] = "";
  try {
    const response = await backend.post(
      "api/product/tag/",
      { ...formValues },
      getConfig()
    );
    if (response.status === 201) {
      dispatch({
        type: types.CREATE_TAG,
        payload: { ...response.data },
      });
      history.push("/product/tag");
    }
  } catch (error) {
    console.log(error);
  }
};

export const getAllTag = () => async (dispatch) => {
  try {
    const response = await backend.get("api/product/tag/", getConfig());
    if (response.status === 200) {
      dispatch({
        type: types.GET_ALL_TAG,
        payload: response.data,
      });
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const deleteTag = (id) => async (dispatch) => {
  try {
    const response = await backend.delete(
      `api/product/tag/${id}/`,
      getConfig()
    );
    if (response.status === 204) {
      dispatch({ type: types.DELETE_TAG, payload: id });
    }
  } catch (error) {
    console.log(error);
  }
};

export const updateTag = (id, formValues) => async (dispatch) => {
  try {
    const response = await backend.patch(
      `api/product/tag/${id}/`,
      formValues,
      getConfig()
    );
    if (response.status === 200) {
      dispatch({ type: types.UPDATE_TAG, payload: { ...response.data } });
    }
  } catch (error) {
    console.log(error.response);
  }
};
